import React from 'react';


import MultiButtonSwitch from '../common/editors/MultiButtonSwitch';

export default function DataIssueStateSwitch({ value, onChange, ... props }) {
  const options = ['family', 'model', 'submodel'];

  const optionColorMap = {
    family: 'violeta-dark',
    model: 'violeta',
    submodel: 'rosa border border-violeta',
  };

  return <MultiButtonSwitch value={value} onChange={onChange} options={options} optionColorMap={optionColorMap} {... props}/>
}
